import { makeStyles } from '@fluentui/react-components';

export const useStyles = makeStyles({
  body: {
    maxHeight: '70vh',
    overflowY: 'auto',
  },

  surface: {
    maxWidth: '880px',
    width: '90vw',
  },
});
